<template>
  <div class="event-banner-container" @click="handleClick">
    <div class="boucher-banner-container hidden-sm-and-down">
      <div class="boucher-left-margin"></div>
      <img src="../../assets/img/landing/matching/boucher_banner.png" alt="boucher-banner" />
      <div class="boucher-right-margin"></div>
    </div>
    <div class="boucher-banner-mobile-container hidden-md-and-up">
      <img src="../../assets/img/landing/matching/boucher_banner_mobile.png" alt="boucher-banner" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventBanner',

  methods: {
    handleClick() {
      this.$router.push('/export-voucher');

      window.dataLayer.push({
        event: 'clickBanner',
        page: 'landing',
        objectType: 'banner',
        objectId: 'exportVoucherBanner',
      });
    },
  },
};
</script>

<style scoped lang="scss">
$boucher-color-left: #001669;
$boucher-color-right: #38b2e6;

.event-banner-container {
  cursor: pointer;
}

.boucher-banner-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 220px;
}

.boucher-banner-container > img {
  width: 1072px;
  height: 100%;
}

.boucher-banner-mobile-container > img {
  width: 100%;
  aspect-ratio: 360/56;
}

.boucher-left-margin {
  flex: 1;
  height: 100%;
  background-color: $boucher-color-left;
}

.boucher-right-margin {
  flex: 1;
  height: 100%;
  background-color: $boucher-color-right;
}
</style>
